import { useState } from "react";
import { useLicenseDetails } from "../../contexts/licenseDetails";
import LicenseService from "../../services/LicensesService";
import Button from "../Button/Button";
import Input from "../Input/Input";
import { UnitSelector } from "../UnitSelector/UnitSelector";
import {
   getZodFieldErrors,
   licenseTransferOwnerSchema,
} from "../../validations/license-subpages.schema";

export function LicenseTransferOwnerPage({ license }) {
   const { setCurrentSubTab, setLicense } = useLicenseDetails();
   const [ownerId, setOwnerId] = useState(
      license?.currentOwnerUnitId ? String(license.currentOwnerUnitId) : null
   );
   const [reason, setReason] = useState("");
   const [errors, setErrors] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);

   async function handleSubmit(event) {
      event.preventDefault();
      const validation = licenseTransferOwnerSchema.safeParse({
         ownerId: ownerId ?? "",
      });
      if (!validation.success) {
         setErrors(getZodFieldErrors(validation.error));
         return;
      }
      setErrors({});

      setIsSubmitting(true);
      try {
         const response = await LicenseService.transferToUnit(
            license.id,
            ownerId,
            reason
         );
         if (response?.status >= 200 && response.status < 300) {
            const refreshedLicense = await LicenseService.getLicense(license.id);
            if (refreshedLicense?.status >= 200 && refreshedLicense.status < 300) {
               setLicense(refreshedLicense.data);
            }
            setCurrentSubTab(null);
         }
      } finally {
         setIsSubmitting(false);
      }
   }

   return (
      <div className="fade-in mt-0.5!">
         <div className="flex flex-row items-center justify-between">
            <h2 className="font-bold! text-[15px]!">Transferir propriedade</h2>
         </div>
         <p className="mt-3! opacity-60 leading-snug!">
            Transfira a licença para outro proprietário.
         </p>
         <form className="flex flex-col gap-3 mt-7!" onSubmit={handleSubmit}>
            <UnitSelector
               modalTitle="Selecione o proprietário"
               inputLabel="Selecione o proprietário *"
               parentId={ownerId}
               setParentId={setOwnerId}
               disabled={isSubmitting}
               error={errors.ownerId}
            />
            <Input
               name="reason"
               id="transfer-reason"
               labelText="Motivo"
               value={reason}
               onChange={({ target }) => setReason(target.value)}
               placeholder=""
               disabled={isSubmitting}
            />
            <div className="w-full flex flex-row items-center justify-end gap-3! mt-6!">
               <Button
                  className="button-white"
                  label="Cancelar"
                  onClick={() => setCurrentSubTab(null)}
                  disabled={isSubmitting}
               />
               <Button
                  className="button-blue"
                  label="Transferir"
                  type="submit"
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
               />
            </div>
         </form>
      </div>
   );
}
